export default {"src":"/_next/static/media/placeholder.8ee2e3fa.svg","height":270,"width":302,"blurWidth":0,"blurHeight":0};